import React from 'react';
import callAPI from '../../../common/call-api';
import ThemedInput from '../../../common/components/ThemedInput';
import {
  ServiceDialog,
  DocTitle,
  TitleBar,
} from '../../../common/components/Layout/StandardPageTemplate/Context';
import Template from '../components/Template';

export default class ForgotPW extends React.Component {
  state = {
    isLoading: false,
    submitSuccess: false,
    serverError: false,
    errors: {
      form: [],
    },
  };

  displaySuccessMessage = () => {
    this.setState(prevState => ({
      ...prevState,
      submitSuccess: true,
      isLoading: false,
    }));
  };

  handleSubmitFailure = ({ resp, json }, handleErrors) => {
    // if 404 display email sent message
    if (resp.status === 404) {
      return this.displaySuccessMessage();
    }

    // otherwise, handle any errors
    const detailedErrors = json.detailedErrors || [];
    handleErrors(
      detailedErrors.length ? { email: detailedErrors[0].message } : {}
    );

    // stop loader and set form error
    return this.setState(prevState => ({
      ...prevState,
      isLoading: false,
      errors: {
        ...prevState.errors,
        form: [json.message],
      },
    }));
  };

  handleSubmit = ({ form, handleErrors }) => {
    // start loading wheel
    this.setState(prevState => ({
      ...prevState,
      isLoading: true,
    }));

    // call forgot password
    callAPI(`/api/cuss/credentials/resetpassword?emailaddress=${form.email}`, {
      method: 'PUT',
    }).then(
      ({ resp, json }) => {
        // if successful, display email sent message
        if (resp.ok || resp.status === 404) {
          return this.displaySuccessMessage();
        }
        return this.handleSubmitFailure({ resp, json }, handleErrors);
      },
      ({ resp, json }) => {
        if (resp.status === 500) {
          return this.setState({ serverError: true });
        }
        return this.handleSubmitFailure({ resp, json }, handleErrors);
      }
    );
  };

  render() {
    const { submitSuccess, isLoading, serverError } = this.state;
    // don't provide form props if email was sent
    const formProps = submitSuccess
      ? {}
      : {
          formInputs: [
            {
              Component: ThemedInput,
              name: 'email',
              type: 'email',
              required: true,
            },
          ],
          formSubmit: this.handleSubmit,
          formErrors: this.state.errors.form,
          formState: {
            email: '',
          },
        };
    return (
      <Template {...formProps} title={'Forgot Password'} isLoading={isLoading}>
        <DocTitle title="Forgot Password | Engage | NFIB" />
        <TitleBar title="" />
        {serverError ? <ServiceDialog /> : null}
        <p
          style={{
            fontSize: '1.6rem',
            marginBottom: '1rem',
          }}
        >
          {submitSuccess
            ? 'An email has been sent. Follow its instructions to reset your password.'
            : 'Enter your email address below.'
          }
        </p>
      </Template>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/auth/Views/ForgotPW.js